export default "__VITE_ASSET__BySTRbNU__"